import React, { useEffect, useState } from "react"
import useDebounce from "../../hooks/useDebounce.hook"
import InputTextForm from "./InputTextForm.molecule"
import { generateRandomId } from "../../utils/strings.utils"

const InputSearch = React.forwardRef(
  (
    {
      value,
      placeholder = "Buscar",
      onChange,
      onBlur,
      inputProps,
      iconProps,
      debounceTimeout = 300,
      clearButton = true,
      ...props
    },
    ref
  ) => {
    const [inputValue, setInputValue] = useState(value)
    const debounceValue = useDebounce(inputValue, debounceTimeout)
    const id = `input-search-${props.label?.replace(/ /g, "-")}-${generateRandomId()}`
    useEffect(() => {
      setInputValue(value)
    }, [value])

    useEffect(() => {
      if (debounceValue === value) return
      onChange({ target: { value: debounceValue } })
    }, [debounceValue])

    const handleClear = () => {
      setInputValue("")
      onChange({ target: { value: "" } })
    }
    return (
      <div className="flex gap-2 align-items-center">
        <InputTextForm
          ref={ref}
          id={id}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          name={props.name}
          className={`${props.className} ${clearButton ? "pr-6" : ""}`}
          label={props.label}
          onBlur={onBlur}
          keyfilter={props.keyfilter}
          placeholder={placeholder}
          disabled={props.disabled}
          maxLength={props.maxLength}
          autoComplete={props.autoComplete}
          autoFocus={props.autoFocus}
          onKeyDown={props.onKeyDown}
          require={props.require}
          optional={props.optional}
          viewOnly={props.viewOnly}
          error={props.error}
          autoTrim={props.autoTrim}
          iconProps={iconProps}
          prefixIcon="pi-search"
          {...inputProps}
        />
        {clearButton && inputValue ?
          <i
            className={`absolute pi pi-times right-0 mr-3`}
            style={{
              color: "light-dark(var(--secondary-color), var(--text-color))",
            }}
            onClick={handleClear}
          />
        : null}
      </div>
    )
  }
)

export default InputSearch
